'use client';

import Script from 'next/script';

export const ThirdPartyScripts = () => {
  return (
    <>
      <Script
        strategy="beforeInteractive"
        src="https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js"
        type="text/javascript"
      />
      <Script
        id="gtm-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag() { dataLayer.push(arguments); }
              gtag('consent', 'default', {
                'ad_storage': 'denied',
                'analytics_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied'
              });
              `,
        }}
      />
    </>
  );
};
